export default __webpack_public_path__ + "static/card-5f6a94a32ee7b3d5b60383247dda0909.png";